import { createContext, ReactNode, useContext, useState } from "react";

export type DeviceConnection = {
	domain: string;
	lanControllerId: number;
}

export type AicoConnectionState = {
	domain: string | null;
	lanControllerId: number | null;
	deviceConnection: DeviceConnection | undefined;
};

type AicoConnectionContextValue = {
	state: AicoConnectionState;
	setDomain: (domain: string | null) => void;
	setLanControllerId: (id: number | null) => void;
};

const AicoConnectionContext = createContext<AicoConnectionContextValue | null>(null);

export function AicoConnectionProvider({ children }: { children: ReactNode }) {
	const [domain, setDomainState] = useState<string | null>(null);
	const [lanControllerId, setLanControllerIdState] = useState<number | null>(null);

	const setDomain = (d: string | null) => {
		setDomainState(d);
		setLanControllerIdState(null); // reset LC when domain changes

		if (d) {
			localStorage.setItem("activedomain", d);
		} else {
			localStorage.removeItem("activedomain");
		} 
	};

	const setLanControllerId = (id: number | null) => {
		setLanControllerIdState(id);
	};

	return (
		<AicoConnectionContext.Provider
			value={{
				state: { 
					domain, 
					lanControllerId, 
					deviceConnection: domain && lanControllerId ? { domain: domain, lanControllerId: lanControllerId } : undefined 
				},
				setDomain,
				setLanControllerId,
			}}
		>
			{children}
		</AicoConnectionContext.Provider>
	);
}

export function useAicoConnection() {
	const ctx = useContext(AicoConnectionContext);
	if (!ctx) {
		throw new Error("useAicoConnection must be used within AicoConnectionProvider");
	}
	return ctx;
}
